import styled from 'styled-components';

const TextIntroStyle = styled.section`
  width: 100%;
  padding: 20px 0;

  div {
    flex-direction: column;
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #dde6eb;
  }

  h2 {
    color: #93da49;
    font-size: 120px;
    font-family: 'FeltThatW01-Regular'
  }
  h3, p {
    color: #273a46;
  }
  p {
    padding: 0 200px;
  }

  @media(max-width: 800px) {
    h2 {
      font-size: 65px;
    }
    h3 {
      font-size: 22px;
      margin: 15px 0;
    }
    p {
      padding: 0 10px;
    }
  }
`;

export default TextIntroStyle;
